module.exports = __webpack_public_path__ + "img/ic_fluent_my_location_24_regular.3e094596.svg";